import { SET_NEW_CONVERSATION_STATUS } from '../types/messageConversationStatus';

export const setNewConversationStatus = (status) => {
  return {
    type: SET_NEW_CONVERSATION_STATUS,
    payload: status
  };
};
